// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__3kr4-","title":"Card_title__3aB0o","details":"Card_details__OVotv","stats":"Card_stats__2-HxU","image":"Card_image__5GIfa"};